import { useQuery } from '@tanstack/react-query';
import { ApiAccountRepository } from 'services/api/account/ApiAccountRepository';
import type { LoginStateEntity } from 'services/api/account/interfaces';

export function useIsLoggedIn({ enabled = true }: { enabled?: boolean } = {}) {
  const accountApi = new ApiAccountRepository();

  const { data, isPending } = useQuery({
    queryKey: ['isLoggedIn'],
    queryFn: async (): Promise<LoginStateEntity> => {
      const response = await accountApi.isLoggedIn();
      return response;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoggedIn: data?.state,
    isLoading: isPending,
  };
}
